<template>
	<div class="">
		<base-page-heading
			title="Offering Options"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="offeringOptionShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<OfferingOptionTable
				@routeOfferingOption="routeOfferingOption"
			/>
		</div>
	</div>
</template>
